/*
 * @Descripttion: $0
 * @version: 
 * @Author: linPing
 * @Date: 2020-07-18 15:33:28
 * @LastEditTime: 2020-07-29 09:16:42
 */
/**
 * 全局配置文件
 */
export default {
	title: "Tsinghua",
	logo: "T",
	key: 'ts', //配置主键,目前用于存储
	indexTitle: 'sass-v2',
	lockPage: '/lock',
	tokenTime: 600000, //token过期时间
	Authorization: 'token',
	//http的status默认放行不才用统一处理的,
	statusWhiteList: [400],
	//配置首页不可关闭
	isFirstPage: false,
	fistPage: {
		label: "首页",	//首页
		value: "",
		params: {},
		query: {},
		meta: {

		},
		group: [],
		close: false
	},
	//配置菜单的属性
	menu: {
		iconDefault: 'icon-caidan',
		props: {
			label: 'name',
			path: 'path',
			icon: 'icon',
			children: 'children'
		}
	}
}
